import { render, staticRenderFns } from "./PriorityTypeTable.vue?vue&type=template&id=81820ada&"
import script from "./PriorityTypeTable.vue?vue&type=script&lang=js&"
export * from "./PriorityTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports